import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, makeStyles } from "@material-ui/core";
import LogoTrustAuto from "v2/components/logo";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "auto",
    marginBottom: "auto",
  },
  logo: {
    display: "flex",
    justifyContent: "center",
    marginLeft: "auto",
    marginRight: "auto",
  },
}));
export function CustomDialog(props) {
  const { onOpen, onClose, title, children, onConfirm, actions } = props;
  const styles = useStyles();
  return (
    <Dialog
      open={onOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">
        <div className={styles.logo}> {title ? title : <LogoTrustAuto />} </div>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>

      {actions && (
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button color="primary" autoFocus onClick={onConfirm}>
            Confirm
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
